require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./reducing-chronic-nuisance-through-regulatory-policy.json") })
        }
      }, "path---reducing-chronic-nuisance-through-regulatory-policy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---reducing-chronic-nuisance-through-regulatory-policy!./.cache/json/reducing-chronic-nuisance-through-regulatory-policy.json
// module id = 968
// module chunks = 231608221292675